// This file should contain the constants for the storage keys used in the application.

export const STORAGE_KEYS = {
  ACCESS_TOKEN: "access_token",
  USER: "user",
  POSTHOG_LAST_IDENTIFIED_USER: "posthog_last_identified_user",
  VIEWED_LOAD_IDS: "viewed_load_ids",
  //Keep updating this file as we add more storage keys.
};